import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class DataService {

    updateMasonry = new Subject<boolean>();

    // issues payg
    issuePaygEmergencyCreditFrequencyDetailResolved = new Subject<boolean>();

    beyondEmergencyCreditItemComponentResolved = new Subject<boolean>();

    issuesNoPaymentsGridItemComponentResolved = new Subject<boolean>();

    issuesLoanGridItemComponentResolved = new Subject<boolean>();

    issuesHighBalanceGridItemComponentResolved = new Subject<boolean>();

    issuesNoCommunicationGridItemComponentResolved = new Subject<boolean>();

    // issuses billing

    billingIssuesSummaryGridItemComponentResolved = new Subject<boolean>();

    issuesBilledInSlaGridItemComponentResolved = new Subject<boolean>();

    issuesBillingAgedDebtGridItemComponentResolved = new Subject<boolean>();

    issuesBillingLatestBillEstimatedGridItemComponentResolved = new Subject<boolean>();


    //issues consumption

    issuesLowConsumptionComponentResolved = new Subject<boolean>();

    issuesHighConsumptionComponentResolved = new Subject<boolean>();

    issuesNoConsumptionComponentResolved = new Subject<boolean>();

    issuesRecentReadDataComponentResolved = new Subject<boolean>();

    issuesReadDataAvailabilityComponentResolved = new Subject<boolean>();


    // consumer detail

    accountBalanceItemComponentResolved = new Subject<boolean>();

    billItemComponentResolved = new Subject<boolean>();

    paymentItemComponentResolved = new Subject<boolean>();

    meterConsumptionItemComponentResolved = new Subject<boolean>();

    creditStatusItemComponentResolved = new Subject<boolean>();

}
